import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import ReactLoading from 'react-loading';
import PrimaryTable from '../helpers/primary-table'
import { useNavigate} from "react-router-dom";
import { catchError } from '../helpers/catch-error'


const Administrators = () => {
    const navigate = useNavigate();

    var columns = React.useMemo(
        () => [
          {
            accessorFn: row => row.first_name + " "+row.last_name,
            id: "name",
            cell: info => info.getValue(),
            header: () => "NAME",
            footer: props => props.column.id
          },
          {
            accessorKey: "email",
            header: "EMAIL",
            footer: props => props.column.id
          },
          {
            accessorFn: row => row?.is_super_admin==1?"YES":"NO",
            id: "is_super_admin",
            cell: info => info.getValue(),
            header: () => "SUPER ADMIN",
            footer: props => props.column.id
          },
          {
            accessorFn: row => localStorage.getItem('@is_super_admin') ==1 ?
            <>
             {row.status == 1  ? 
               <>
                <button className="btn btn-sm btn-success me-1" onClick={() => editAdministrator(row.id)}>Edit</button>
                <button className="btn btn-sm btn-warning me-1" onClick={() => toggleStatus(row.id, 0)}>De-activate</button>
                </>
                :
                <button className="btn btn-sm btn-danger" onClick={() => toggleStatus(row.id, 1)}>Activate</button>
             }
                </>
                
                :
                <></>
,
            id: "action",
            cell: info => info.getValue(),
            header: () => "Action",
            enableColumnFilter: false,
            enableSorting: false,
            

          },
        ],
        []
      )
    
    
    const [isBtn, setIsBtn] = useState(false);
    const [addMode, setAddMode] = useState(false);
    const [isAdministratorModalOpen, setIsAdministratorModalOpen] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [Administrators, setAdministrators] = useState(null);
    const [administratorAdd, setAdministratorAdd] = useState(null);
    const [administratorEdit, setAdministratorEdit] = useState(null);
    const [inputError, setInputError] = useState(false);


    useEffect(() => {
       
      getAdministrators();


    }, []);

   
    const getAdministrators = async () => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-administrators",
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {
                if (response?.data?.status) {
                    setAdministrators(response?.data?.administrators)
                    setIsLoading(false);
                } else {
                    Swal.fire({ icon: "error", title: "administrator Info", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {
                catchError(error,navigate)
            });


    }


    const addAdministrator = async () => {


        setAdministratorAdd(null);
        setAddMode(true);

    }


    const saveAdministrator = async (e) => {


        setIsBtn(true);
        let error_flag = false;


        if (!administratorAdd?.first_name || !administratorAdd?.last_name || !administratorAdd?.email
            || !(administratorAdd?.first_name.match(/^[A-Za-z'.\-, ]+$/)) || !(administratorAdd?.last_name.match(/^[A-Za-z'.\-, ]+$/))
            || !(administratorAdd?.email.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g))) {

            error_flag = true;
        }

        if (error_flag) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var administrator_info = {
                first_name: administratorAdd?.first_name,
                last_name: administratorAdd?.last_name,
                email: administratorAdd?.email,
                is_super_admin: administratorAdd?.is_super_admin,


            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-administrator", administrator_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    getAdministrators();
                    setAddMode(false)

                } else {

                    Swal.fire({ icon: "error", title: "Administrator Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                catchError(error,navigate)
                setIsBtn(false);

            });

        }


    }


    const editAdministrator = async (id) => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-administrator-by-id/" + id,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {
                     setAdministratorEdit(response?.data?.administrator);
                    setIsAdministratorModalOpen(true);

                } else {
                    Swal.fire({ icon: "error", title: "administrator Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {
                catchError(error,navigate)
            });


    }


    const updateAdministrator = async (e) => {


        setIsBtn(true);
        let error_flag = false;

        if (!administratorEdit?.first_name || !administratorEdit?.last_name || !administratorEdit?.email
            || !(administratorEdit?.first_name.match(/^[A-Za-z'.\-, ]+$/)) || !(administratorEdit?.last_name.match(/^[A-Za-z'.\-, ]+$/))
            || !(administratorEdit?.email.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g))) {

            error_flag = true;
        }

        if (error_flag) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var administrator_info = {
                id: administratorEdit?.id,
                first_name: administratorEdit?.first_name,
                last_name: administratorEdit?.last_name,
                email: administratorEdit?.email,
                is_super_admin: administratorEdit?.is_super_admin,


            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-administrator", administrator_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    getAdministrators();
                    setIsAdministratorModalOpen(false)

                } else {

                    Swal.fire({ icon: "error", title: "Administrator Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                catchError(error,navigate)
                setIsBtn(false);

            });

        }


    }



    const toggleStatus = async (id, status) => {

        var administrator_info = {
            id: id,
            status: status,
        }
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/toggle-administrator-status", administrator_info, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {

                getAdministrators();
                setIsAdministratorModalOpen(false)

            } else {

                Swal.fire({ icon: "error", title: "Administrator Info", text: response?.data?.message });

            }
            setIsBtn(false)

        }).catch(function (error) {

            catchError(error,navigate)
            setIsBtn(false);

        });

    }
    return (

        <>
         <div className="row pb-2 mt-4">
            <div className="col-md-4 col-sm-12 ps-3 "> 
              <h3 className="text-dark my-0">ADMINISTRATORS</h3>
              </div>

            <div className="col-md-8 col-sm-12 text-md-end -2">
              {!addMode && localStorage.getItem('@is_super_admin') ==1 &&
                             <>
                       <button onClick={() => addAdministrator()} className="btn btn-success mx-1" type="button">ADD NEW</button>
                            
                </>
              }
            </div>
            </div>

                  
                    {(addMode) &&
                        <>

<div className="card card-form card-primary mb-3">
    <div className="card-heading px-3 py-2"><h6 className="fw-bold my-0">ADD NEW FACILITY</h6></div>
    <div className="card-body">

                            <form method="post" action="" encType="multipart/form-data" name="updates" id="updates">
                                <div className="row px-3 py-2 gx-2 ">
                                    <div className="col-3">
                                        <label className="control-label">FIRST NAME*</label>
                                        <input type="text" name="first_name" id="first_name"
                                            className="form-control"
                                            value={administratorAdd?.first_name}
                                            onChange={(e) =>
                                                setAdministratorAdd({ ...administratorAdd, first_name: e.target.value })
                                            }
                                        />
                                        {inputError &&
                                            (!administratorAdd?.first_name || !(administratorAdd?.first_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                <span className="text-danger">Enter valid first name</span>
                                            )}
                                    </div>
                                    <div className="col-3">
                                        <label className="control-label">LAST NAME*</label>
                                        <input type="text" name="last_name" id="last_name"
                                            className="form-control"
                                            value={administratorAdd?.last_name}
                                            onChange={(e) =>
                                                setAdministratorAdd({ ...administratorAdd, last_name: e.target.value })
                                            }
                                        />
                                        {inputError &&
                                            (!administratorAdd?.last_name || !(administratorAdd?.last_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                <span className="text-danger">Enter valid last name</span>
                                            )}
                                    </div>

                                    <div className="col-3">
                                        <label className="control-label">EMAIL*</label>
                                        <input type="text" name="email" id="email"
                                            className="form-control"
                                            value={administratorAdd?.email}
                                            onChange={(e) =>
                                                setAdministratorAdd({ ...administratorAdd, email: e.target.value })
                                            }
                                        />
                                        {inputError &&
                                            (!administratorAdd?.email || !administratorAdd?.email.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) && (
                                                <span className="text-danger">Enter a valid email</span>
                                            )}
                                    </div>
                                    <div className="col-3">
                                        <label className="control-label">SUPER ADMIN*</label><br/>
                                        <input name="is_super_admin" className="form-check-input mx-3" type="checkbox"
                                                    checked={administratorAdd?.is_super_admin ? true : false}
                                                    onClick={e => {
                                                        setAdministratorAdd({ ...administratorAdd, is_super_admin: !administratorAdd.is_super_admin})
                                                       
                                                    }} />
                                        
                                    </div>


                                </div>
                               
                               

                                  

                            </form>
                            </div>
                            <div className="card-footer"> 
                                <div className="row px-3 py-1 gx-2 ">
                                <div className="col-md-12 col-sm-12 text-center">
                                    <button onClick={() => saveAdministrator()} className="btn btn-success me-1 mt-1" type="button">SAVE</button>
                                    <button onClick={() => { setAddMode(false); setAdministratorAdd(null); }} className="btn btn-warning me-1 mt-1" type="button">CANCEL SAVE</button>
                                
                                    </div>

                                    </div>
                            </div>
                            </div>
                        </>
                    }

{isLoading ?
          <div className="container text-center">  
            <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />
           </div>
          :
          <>


            {Administrators &&
<>
<div className="card card-form card-primary  h-100 " >
      <div className="card-body p-0 mb-5" >

       
<PrimaryTable columns={columns} data={Administrators} />
</div></div>
              </>
            }
          </>
        }



        

            <Modal animation={false}
                show={isAdministratorModalOpen}
                onHide={() => { setIsAdministratorModalOpen(false); }}
                keyboard={false}
                backdrop="static"
                id="administrator-modal"
                size="lg"
            >
                <Modal.Header><h3 className="m-0 p-0">UPDATE ADMIN</h3></Modal.Header>
                <Modal.Body>

                    <div className="card card-form border-0" >
                        <div className="card-body p-0" >

                            <div className="modal-inner-content ">



                                <form method="post" action="" encType="multipart/form-data" name="updates" id="updates">
                                    <div className="row px-3 py-2 gx-2 ">
                                        <div className="col-3">
                                            <label className="control-label">FIRST NAME*</label>
                                            <input type="text" name="first_name" id="first_name"
                                                className="form-control"
                                                value={administratorEdit?.first_name}
                                                onChange={(e) =>
                                                    setAdministratorEdit({ ...administratorEdit, first_name: e.target.value })
                                                }
                                            />
                                            {inputError &&
                                                (!administratorEdit?.first_name || !(administratorEdit?.first_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                    <span className="text-danger">Enter valid first name</span>
                                                )}
                                        </div>
                                        <div className="col-3">
                                            <label className="control-label">LAST NAME*</label>
                                            <input type="text" name="last_name" id="last_name"
                                                className="form-control"
                                                value={administratorEdit?.last_name}
                                                onChange={(e) =>
                                                    setAdministratorEdit({ ...administratorEdit, last_name: e.target.value })
                                                }
                                            />
                                            {inputError &&
                                                (!administratorEdit?.last_name || !(administratorEdit?.last_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                    <span className="text-danger">Enter valid last name</span>
                                                )}
                                        </div>

                                        <div className="col-3">
                                            <label className="control-label">EMAIL*</label>
                                            <input type="text" name="email" id="email"
                                                className="form-control"
                                                value={administratorEdit?.email}
                                                onChange={(e) =>
                                                    setAdministratorEdit({ ...administratorEdit, email: e.target.value })
                                                }
                                            />
                                            {inputError &&
                                                (!administratorEdit?.email || !administratorEdit?.email.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) && (
                                                    <span className="text-danger">Enter a valid email</span>
                                                )}
                                        </div>
                                        




                                        <div className="col-3">
                                        <label className="control-label">SUPER ADMIN*</label><br/>
                                        <input name="is_super_admin" className="form-check-input mx-3" type="checkbox"
                                                    checked={administratorEdit?.is_super_admin ? true : false}
                                                    onClick={e => {
                                                        setAdministratorEdit({ ...administratorEdit, is_super_admin: !administratorEdit.is_super_admin})
                                                       
                                                    }} />
                                        
                                    </div>






                                    </div>



                                </form>




                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="row">
                        <div className="col text-center">
                            <button className="btn btn-sm btn-success me-1" onClick={() => updateAdministrator()} >UPDATE</button>
                            <button className="btn btn-sm btn-warning" onClick={() => setIsAdministratorModalOpen(false)} >CLOSE</button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>



        </>

    )

}

export default Administrators;